export default __webpack_public_path__ + "static/media/hellowizz.60250003.png";